import { render, staticRenderFns } from "./ChooseInspectionRoutePoint.vue?vue&type=template&id=f85ba1c4&scoped=true"
import script from "./ChooseInspectionRoutePoint.vue?vue&type=script&lang=js"
export * from "./ChooseInspectionRoutePoint.vue?vue&type=script&lang=js"
import style0 from "./ChooseInspectionRoutePoint.vue?vue&type=style&index=0&id=f85ba1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85ba1c4",
  null
  
)

export default component.exports